function removeClassMenu(moreSearchContent) {
  moreSearchContent.forEach((el) => {
    el.classList.remove('active');
  });
}

export default function SearchBlock() {
  const searchInput = document.querySelector('.search-container .search__block-input');
  const searchBtn = document.querySelector('.search-container .search-btn');
  const iconX = document.querySelector('.search-container .search__block-icon');
  const seeMoreBtn = document.querySelectorAll('[data-id="seeMoreBtn"]');

  if (searchBtn) {
    searchBtn.addEventListener('click', () => {
      if (searchInput.value.length) {
        window.location = `?s=${searchInput.value}`;
      }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (searchInput.value.length) {
          window.location = `?s=${searchInput.value}`;
        }
      }
    });
  }

  if (seeMoreBtn) {
    seeMoreBtn.forEach((el) => {
      el.addEventListener('click', function onclick(e) {
        e.preventDefault();
        const moreSearchContent = this.closest('.content-container').querySelectorAll('.result_link.active');
        removeClassMenu(moreSearchContent);
        this.closest('.content-container').querySelector('.more_in_this_section').style.display = 'none';
      });
    });
  }

  if (iconX) {
    iconX.onclick = () => {
      searchInput.value = '';
      iconX.classList.remove('active');
    };
  }

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      if (e.currentTarget.value === '') {
        iconX.classList.remove('active');
      } else {
        iconX.classList.add('active');
      }
    });
  }
}
